module.exports = __webpack_public_path__ + "img/nt85-06-82-1.prt.a207ba7c.jpg";